export default __webpack_public_path__ + "static/box1-ab2e02e70fb97c272af0c491d4830eef.png";